import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BusinessArea, DocumentType } from '../../models/model';
import { environment } from '../../../environments/environment';
import { urlConstants } from '../../common/urlConstants';;
import { RetrievalSearchResults, SearchField } from '../../models/search-field';
import { GridColumnHeader } from '../../models/grid-column-header';
import { DocumentHistoryResponse } from '../../models/document-history.model';
import { WorkflowHistoryResponse } from '../../models/workflow-history.model';

@Injectable({
  providedIn: 'root'
})
export class RetrievalService {

  constructor(private readonly http: HttpClient) { }

  getBusinessAreaList(userGPID: string, systemId: string): Observable<BusinessArea[]> {
    const routeUrl = `${environment.apiUrl}${urlConstants.GetBusinessAreas}${userGPID}/${systemId}`;
    return this.http.get<BusinessArea[]>(routeUrl);
  }

  getDocumentHistory(userGPID: string, systemId: string, documentId: string): Observable<DocumentHistoryResponse> {
    const routeUrl = `${environment.apiUrl}${urlConstants.GetDocumentHistory}${userGPID}/${systemId}/${documentId}`;
    return this.http.get<DocumentHistoryResponse>(routeUrl);
  }

  getWorkflowHistory(userGPID: string, systemId: string, documentId: string): Observable<WorkflowHistoryResponse[]> {
    const routeUrl = `${environment.apiUrl}${urlConstants.viewDocumentWorkFlowHistoryURL}${userGPID}/${systemId}/${documentId}`;
    return this.http.get<WorkflowHistoryResponse[]>(routeUrl);
  }

  getDocumentTypeList(selectedBusinessArea: number, userGPID: string, systemId: string): Observable<DocumentType[]> {
    const routeUrl = `${environment.apiUrl}${urlConstants.GetDocumentTypesUploadURL}${userGPID}/${systemId}/${selectedBusinessArea}`;
    return this.http.get<DocumentType[]>(routeUrl);
  }

  getSearchFields(userGPID: string, systemId: string, businessAreaId: string, selectedDocumentType?: string): Observable<SearchField[]> {
    let routeUrl = `${environment.apiUrl}${urlConstants.retrievalSearchField}${userGPID}/${systemId}/${businessAreaId}`;
    if (selectedDocumentType) {
      routeUrl += `/${selectedDocumentType}`;
    }
    return this.http.get<SearchField[]>(routeUrl);
  }

  getGridColumnHeaders(userGPID: string, systemId: string, girdId: string = "0",
    businessAreaId: string = "0", QueueId: string = "0", workflowId: string = "0", vendorCode: string = "0"): Observable<GridColumnHeader[]> {
    const routeUrl = `${environment.apiUrl}${urlConstants.getGridColumnHeadersURL}${userGPID}/${systemId}/${girdId}/${businessAreaId}/${QueueId}/${workflowId}/${vendorCode}`;
    return this.http.get<GridColumnHeader[]>(routeUrl);
  }

  getLink(userGPID: string, systemId: string, documentId: string, type: string = "document"): Observable<string> {
    const routeUrl = `${environment.apiUrl}${urlConstants.link}${userGPID}/${systemId}/${documentId}/${type}`;
    return this.http.get(routeUrl, { responseType: 'text' });
  }

  getSearchResults(formbody: any): Observable<RetrievalSearchResults> {
    const routeUrl = `${environment.apiUrl}${urlConstants.retrievalSearchResults}`;
    return this.http.post<RetrievalSearchResults>(routeUrl, formbody);
  }

  deleteDocument(formbody: any): Observable<string> {
    const routeUrl = `${environment.apiUrl}${urlConstants.deleteDocument}`;
    return this.http.post<string>(routeUrl, formbody);
  }

  exportToExcel(formbody: any, selectedDocumentType?: string): Observable<Blob> {
    let routeUrl = `${environment.apiUrl}${urlConstants.exportExcel}`;
    if (selectedDocumentType) {
      routeUrl += `/${selectedDocumentType}`;
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=utf-8'
    });

    return this.http.post(routeUrl, formbody, {
      headers,
      responseType: 'blob'
    });
  }

  ViewMultiDocument(formbody: any): Observable<Blob> {
    const routeUrl = `${environment.apiUrl}${urlConstants.showMultiDocuments}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=utf-8',
      'Accept': 'application/pdf', // Set the accept header as per your requirement
    });

    return this.http.post(routeUrl, formbody, {
      headers,
      responseType: 'blob' // Expect a binary response (PDF/ZIP)
    });
  }

  getGridColumns(userGPID: string, systemId: string, gridId: string = "0", businessAreaId: string = "0", queueId: string = "0", workflowId: string = "0", vendorCode: string = "0"): Observable<GridColumnHeader[]> {
    return this.getGridColumnHeaders(userGPID, systemId, gridId, businessAreaId, queueId, workflowId, vendorCode);
  }
}
